/* jshint -W071, -W072, -W074 */
angular.module('PinMeTo.directives').directive('pmtFileManagerItem', [
	'$i18next',
	function ($i18next) {
		'use strict';

		return {
			scope: {
				file: '<',
				selectFile: '<',
				supportMultipleSelect: '@',
				enableCropper: '@',
				maxWidth: '@',
				minWidth: '@',
				minHeight: '@',
				minDuration: '@',
				maxDuration: '@',
				maxFileSize: '@',
				minFileSize: '@',
				mediaType: '@',
				fileType: '@',
				maxVideoBitrate: '@',
				maxAudioBitrate: '@',
				place: '=',
				network: '@',
				type: '@',
				mediaLimitReached: '<'
			},
			link: function (scope) {
				scope.siteName = scope.$parent.siteName;
				scope.uploadedBy = scope.file.uploadedBy?.name || '--';
				const metaData = scope.file.metaData;

				if (scope.place) {
					const media = scope.place.networkMedia[scope.network];
					const currentMedia =
						scope.type === 'profile' ? media.profileImage.url : media.coverImage.url;

					scope.isCurrentImage = currentMedia === scope.file.url ? true : false;
				}

				var durationInfo = (function () {
					if (!metaData.duration) {
						return '';
					}
					var duration = metaData.duration;
					var holeHours = Math.floor(duration / 3600);
					var holeMinutes = Math.floor((duration % 3600) / 60);
					var holeSeconds = Math.floor((duration % 3600) % 60);
					if (duration < 10) {
						return ', ' + holeSeconds + '.' + Math.floor(10 * (duration - holeSeconds)) + 's';
					}
					if (duration < 60) {
						return ', ' + holeSeconds + 's';
					}
					if (holeHours < 1) {
						return ', ' + holeMinutes + 'm ' + holeSeconds + 's';
					}
					return ', ' + holeHours + 'h' + holeMinutes + 'm ' + holeSeconds + 's';
				})();

				let bit_rate = (function () {
					let v = !metaData.video_bitrate
						? ''
						: `, video: ${Math.round(metaData.video_bitrate)} kbps`;
					let a = !metaData.audio_bitrate
						? ''
						: `, audio: ${Math.round(metaData.audio_bitrate)} kbps`;
					return v + a;
				})();
				scope.metaDataInfo =
					'' + metaData.width + ' x ' + metaData.height + ' px' + durationInfo + bit_rate;

				scope.shouldDisableSelection = () => {
					if (scope.file.error && scope.enableCropper !== 'true') {
						return true;
					}
					if (metaData.width < scope.minWidth || metaData.height < scope.minHeight) {
						return true;
					}
					if (scope.minFileSize && scope.file.size < scope.minFileSize) {
						return true;
					}
					if (scope.mediaType === 'image' && scope.file.contentType === 'image/gif') {
						return true;
					}
					if (!scope.file.selected && scope.mediaLimitReached) {
						return true;
					}
				};
			},
			templateUrl: 'pmtShared/filemanager/pmtFileManagerItemView.html'
		};
	}
]);
/* jshint +W071, +W072, +W074 */
